import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/dist/vuetify.min.css'


// WEBPACK FOOTER //
// src/plugins/css.js